<template>
  <!-- <DBox
    :id="'cmp-settings-users-external_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('External User')}`"
    @add_click="onAddClick"
  > -->
  <div class="settings-users-external_list">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search" style="max-width: 360px">
        <InputField
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
      <button
        style="margin-top: 8px; margin-left: 0px"
        class="dt-button v5 s8"
        @click="refresh"
      >
        {{ $t("refresh") }}
      </button>
      <div class="right-space"></div>
    </div>
    <div class="dt-page--body">
      <NTable
        class="user-list-table h1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr :title="item.given_name">
            <td @click="onUserItemClick(item)" v-bind="tdcon('users')">
              <span :title="item['user_name']">
                {{ item["user_name"] }}
              </span>
            </td>
            <td v-bind="tdcon('fullname')">
              <TextField2
                :showLabel="false"
                :id="'given_name'"
                :value="item['given_name']"
                @blur="(e) => onTextInputBlur(e, item)"
                :bb="'0px'"
              />
            </td>
            <td v-bind="tdcon('language')">
              <Dropdown2
                class="dbox1"
                :showLabel="false"
                :options="systemLanguagesTV"
                :selected="
                  systemLanguagesTV.find((e) => e.value == item.language)
                "
                v-on:selectedChange="
                  (e) => onDropdownChange('language', e, item)
                "
                :bb="'0px'"
              />
            </td>

            <td v-bind="tdcon('email_1')">
              <!-- <input
                type="text"
                class="dbox-table--textfield"
                name="email"
                :id="item.user_id + 'email'"
                :value="item['email']"
                v-on:blur="(e) => onTextInputBlur(e, 'email', item)"
              /> -->
              <TextField2
                :showLabel="false"
                :id="'email'"
                :value="item['email']"
                @blur="(e) => onEmailChange(e, item)"
                :bb="'0px'"
                :placeholder="$t('email')"
                :validators="emailValidators"
                @validated="onValidation"
              />
              <!-- <TextField2
                :showLabel="false"
                :id="'email'"
                :value="item['email']"
                @blur="(e) => onTextInputBlur(e, item)"
                :bb="'0px'"
              /> -->
            </td>

            <td v-bind="tdcon('options')">
              <img
                @click.stop="(e) => onUserDelete(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1 ut-center"
                :alt="$t('delete_user')"
                :title="$t('delete_user')"
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </div>
  <!-- </DBox> -->
</template>
  
<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { mapGetters } from "vuex";
import { subscribeSubject } from "../../../../utility";
import { Subject } from "rxjs";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import { createValidator } from "@plugins/text-field";
import isEmail from "validator/lib/isEmail";
import { AccountsService } from "../../../../modules/royalty/services/accounts.service";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    externalUserList: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      searchString: "",
      searchSubject$: new Subject(),
      validationResult: {},
      selectedItem: {},
      emailNameSubject: new Subject(),
      tableConfig: createNTableConfig({
        fullHeight: true,
        footer: false,
      }),
    };
  },
  computed: {
    ...mapGetters({
      systemLanguagesTV: "systemLanguagesTV",
    }),

    emailValidators() {
      return [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email",
        }),
        createValidator({
          name: "uniqEmail",
          validatorFn: this.checkEmailUniq,
          errorMessage: "Email is already exist",
        }),
      ];
    },
    headers: () => [
      createTableHeader("users", { text: "external_username" }),
      createTableHeader("fullname"),
      createTableHeader("language"),
      createTableHeader("email_1"),
      createTableHeader("options", { text: false, mw: 50 }),
    ],
    list: function () {
      console.log("this.externalUserList", this.externalUserList);
      return this.externalUserList.ext_users || [];
    },
  },
  mounted() {
    subscribeSubject(this, this.searchSubject$, (searchString) => {
      this.$emit("search", searchString);
    });

    subscribeSubject(this, this.emailNameSubject, async (value) => {
      const checkUnique =
        await AccountsService.checkUniquenessOfExternalUserEmail(value);
      const is_email_taken = checkUnique.data.is_email_taken;
      if (is_email_taken) {
        this.duplicateEmail = value;
        this.$nextTick(() => {
          this.email = value;
        });
        NotificationService.showNotification({
          text: this.$t("external_user_email_taken"),
          timeout: 3000,
          type: "error",
        });
        this.$emit("onTextInputBlur", {
          name: "email",
          value: this.selectedItem.email,
          item: this.selectedItem,
        });
      } else {
        this.$emit("onTextInputBlur", {
          name: "email",
          value: value,
          item: this.selectedItem,
        });
      }
    });
  },

  methods: {
    async onEmailChange({ name, value }, item) {
      if (isEmail(value)) {
        this.email = value;
        this.selectedItem = { ...item };
        this.emailNameSubject.next(value);
      }
    },

    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },

    checkUserNameUniq(value) {
      return value == this.duplicateUserName ? false : true;
    },
    checkEmailUniq(value) {
      return value == this.duplicateEmail ? false : true;
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(this.searchString);
    },
    onUserItemClick: function (item) {
      this.$emit("onUserItemClick", item);
    },
    onAddClick: function () {
      this.$emit("add_click", "create_external_user");
    },
    refresh: function () {
      this.searchString = "";
      this.$emit("refresh", true);
    },
    onUserDelete: function (item) {
      this.$emit("onUserDelete", item);
    },
    onTextInputBlur: function (e, item) {
      this.$emit("onTextInputBlur", {
        name: e.name,
        value: e.value,
        item: item,
      });
    },
    onDropdownChange: function (name, value, item) {
      item[name] = value.value;
      this.$emit("onTextInputBlur", {
        name,
        value: value.value,
        item: item,
      });
    },
    onDeleteTaxType: function (item) {
      this.$emit("delete_click", item);
    },
    onTaxTypeEdit: function (item) {
      this.$emit("edit_click", item);
    },
    onTaxTypeDragstart: function (event, item) {
      if (!item) {
        return;
      }
      event.dataTransfer.setData("text", JSON.stringify(item));
    },
    onTaxDeductionFlagChange: function (event, name, item) {
      const value = event.target.checked ? "1" : "0";
      this.$emit("changed", { name, value, item });
    },
    descriptionText(item) {
      return `${item["tax_description"]}`;
    },
    // MARK: Methods
  },
};
</script>
<style lang="scss">
.cmp-settings-users-external_list {
  .settings-users-external_list {
    overflow: hidden;

    .dt-ntable {
      --ntable-height: none !important;
    }
  }
}
</style>
  